import { createContext } from 'react';

import type { AppsStudiesState } from './apps-studies.model';

export const AppsStudiesContext = createContext<AppsStudiesState | undefined>(undefined);

AppsStudiesContext.displayName = 'AppsStudiesContext';
